import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import VisibilityChecker from './components/VisibilityChecker';
import EmailVerification from './components/EmailVerification';
import AnalysisLoading from './components/AnalysisLoading';
import AnalysisResults from './components/AnalysisResults';
import './App.css';

function AppContent() {
  const location = useLocation();

  const handleLogoClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="App">
      {location.pathname === '/' && <Header onLogoClick={handleLogoClick} />}
      <main>
        <Routes>
          <Route path="/" element={<VisibilityChecker />} />
          <Route path="/verify-email" element={<EmailVerification />} />
          <Route path="/analysis-loading" element={<AnalysisLoading />} />
          <Route path="/results" element={<AnalysisResults />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;